import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import AppText from "../_shared/components/AppText";
import SideMenu from "../_shared/components/SideMenu";
import BackIcon from "../_shared/components/BackIcon";

import VideoIcon from "../../assets/images/VideoIcon.png";
import PdfIcon from "../../assets/images/pdfIcon.png";
import PlayVideo from "../../assets/images/icons/Play_video.png";

import OpenIcon from "../../assets/images/icons/download_icon.png";
import { useState } from "react";
import CloseIcon from "../_shared/components/CloseIcon";

function Help(props) {
  const [openVideo, setOpenVideo] = useState(false);

  function renderPdfAndVideo() {
    return (
      <div className="row" style={{ marginTop: 20 }}>
        <div
          style={styles.pdfCard}
          onClick={() =>
            window.open("https://spaces-api.cinquanta3.it/app-tutorial.pdf")
          }
          //   onClick={() => (setSelectedMenu(pdf.id))}
        >
          <img
            alt=""
            src={PdfIcon}
            style={{
              height: 300,
              aspectRatio: 0.7,

              objectFit: "contain",
            }}
          ></img>
          <div className="row">
            <img
              alt=""
              src={OpenIcon}
              style={{
                marginTop: 6,
                height: 15,
                width: 15,
                marginRight: 4,
                objectFit: "contain",
              }}
            ></img>
            <div>
              <AppText small bold>
                {" "}
                scarica pdf
              </AppText>
              <AppText small light>
                download the pdf file
              </AppText>
            </div>
          </div>
        </div>
        <div style={styles.pdfCard} onClick={() => setOpenVideo(true)}>
          <div
            style={{
              background: `url(${VideoIcon})`,
              backgroundSize: "contain",
              backgroundPositionY: "bottom",
              marginBottom: 4,
              //
              backgroundRepeat: "no-repeat",
              height: 300,
              width: 800,
            }}
          >
            <img
              style={{
                position: "relative",

                top: 120,
                left: 230,
                height: 50,
                width: 50,
              }}
              alt=""
              src={PlayVideo}
            />
          </div>

          <div className="row">
            <div>
              <AppText small bold>
                guarda il video
              </AppText>
              <AppText small light>
                watch the video
              </AppText>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderMenu() {
    return (
      <div className="rootMenu">
        <SideMenu></SideMenu>
        <div className="rootContent">
          <div className="row">
            <div>
              <BackIcon />
            </div>
            <div>
              <div className="row">
                <div className="titleHomeSpaces">
                  Istruzioni di utilizzo dell'App
                </div>
                <div className="titleHomeSpacesNoBold">
                  / App operating instructions
                </div>
              </div>
              <div className="row">
                <div className="subtitleHomeSpacesBold">
                  {" "}
                  Scarica il pdf o guarda il video
                </div>
                <div className="subtitleHomeSpaces">
                  {" "}
                  / Download the PDF file or watch the video
                </div>
              </div>
            </div>
          </div>
          <div className="rooms"></div>
          <div style={{ marginLeft: 40 }}>{renderPdfAndVideo()}</div>
          {/* {selectedRoom && getLayouts()} */}
        </div>
      </div>
    );
  }

  function renderVideo() {
    return (
      <div className="rootMenu">
        {" "}
        <div className="rootContent">
          <div className="centerPage">
            <div className="rightPage">
              <CloseIcon onClick={() => setOpenVideo(false)} />
            </div>
            <video
              autoPlay
              src={"https://spaces-api.cinquanta3.it/app-tutorial.mp4"}
              width="100%"
              height="100%"
              controls
            />
          </div>
        </div>
      </div>
    );
  }

  return openVideo ? renderVideo() : renderMenu();
}
const styles = {
  inline: {
    display: "flex",
    flexDirection: "row",
  },
  pdfCard: {
    // width: 240,
    marginRight: 50,
    marginBottom: 50,
    maxHeight: 350,
    cursor: "pointer",
    // border: "0.1px solid black",
  },
};
export default Help;
